module.exports = __webpack_public_path__ + "img/生日有礼.a8816ec7.png";